import * as Sentry from "@sentry/vue";
import i18next from "i18next";

export default (componentName, opt = {}) => {
  let text = null;
  const navigation =
    opt.customKey || `navigation:loadingMessages.${componentName}.title`;
  if (i18next.exists(navigation)) {
    text = i18next.t(navigation);
  } else {
    if (process.env.NODE_ENV != "production") {
      Sentry.withScope(scope => {
        scope.setLevel("info");
        Sentry.captureMessage(
          `Key is missing ${opt.customKey || navigation}. In language ${
            i18next.language
              ? i18next.language.toUpperCase()
              : "unknown/import failed "
          }`
        );
      });
    }
    text = componentName;
  }

  return text;
};
